import React, { useState } from "react";

// Recording layout picker icons (SVG paths)
const layoutIcons = {
  gallery: (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
      <rect x="2" y="2" width="12" height="12" rx="2" fill="currentColor" opacity="0.7"/>
      <rect x="18" y="2" width="12" height="12" rx="2" fill="currentColor" opacity="0.7"/>
      <rect x="2" y="18" width="12" height="12" rx="2" fill="currentColor" opacity="0.7"/>
      <rect x="18" y="18" width="12" height="12" rx="2" fill="currentColor" opacity="0.7"/>
    </svg>
  ),
  focus: (
    <svg width="40" height="28" viewBox="0 0 40 28" fill="none">
      {/* Single large focused participant - wide rectangle */}
      <rect x="2" y="2" width="36" height="24" rx="2" fill="currentColor" opacity="0.7"/>
    </svg>
  ),
  'speaker-top': (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
      <rect x="2" y="2" width="28" height="18" rx="2" fill="currentColor" opacity="0.7"/>
      <rect x="2" y="22" width="8" height="8" rx="1.5" fill="currentColor" opacity="0.5"/>
      <rect x="12" y="22" width="8" height="8" rx="1.5" fill="currentColor" opacity="0.5"/>
      <rect x="22" y="22" width="8" height="8" rx="1.5" fill="currentColor" opacity="0.5"/>
    </svg>
  ),
  'speaker-side': (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
      <rect x="2" y="2" width="20" height="28" rx="2" fill="currentColor" opacity="0.7"/>
      <rect x="24" y="2" width="6" height="8" rx="1.5" fill="currentColor" opacity="0.5"/>
      <rect x="24" y="12" width="6" height="8" rx="1.5" fill="currentColor" opacity="0.5"/>
      <rect x="24" y="22" width="6" height="8" rx="1.5" fill="currentColor" opacity="0.5"/>
    </svg>
  ),
};

const layoutOptions = [
  { id: 'gallery', label: 'Gallery', desc: 'All participants equal size' },
  { id: 'focus', label: 'Focus', desc: 'One large, others small' },
  { id: 'speaker-top', label: 'Speaker Top', desc: 'Active speaker on top' },
  { id: 'speaker-side', label: 'Speaker Side', desc: 'Active speaker on the side' },
];

const RecordingLayoutPicker = ({ onCancel, onStart }) => {
  const [selected, setSelected] = useState('speaker-top');
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-gradient-to-br from-[#001233]/80 to-[#6a1fbf]/50 backdrop-blur-md">
      <div className="absolute inset-0" onClick={onCancel} />
      <div className="relative bg-[#0d0d2b]/95 backdrop-blur-xl border border-white/15 rounded-2xl p-8 w-full max-w-lg mx-4 text-white shadow-2xl">
        <h3 className="text-xl font-semibold mb-2 text-center">
          Start recording this meeting?
        </h3>
        <p className="text-sm text-[#cfcfcf] mb-6 text-center">
          Choose a layout for the recording. Participants will be notified.
        </p>
        <div className="grid grid-cols-2 gap-3 mb-6">
          {layoutOptions.map((opt) => (
            <button
              key={opt.id}
              onClick={() => setSelected(opt.id)}
              className={`flex flex-col items-center gap-2 p-4 rounded-xl border-2 transition-all duration-200 ${
                selected === opt.id
                  ? 'border-[#6a1fbf] bg-[#6a1fbf]/20 shadow-lg shadow-[#6a1fbf]/20'
                  : 'border-white/10 bg-white/5 hover:bg-white/10 hover:border-white/20'
              }`}
            >
              <div className={`${selected === opt.id ? 'text-[#a855f7]' : 'text-white/60'}`}>
                {layoutIcons[opt.id]}
              </div>
              <span className="text-sm font-medium">{opt.label}</span>
              <span className="text-xs text-white/50 text-center leading-tight">{opt.desc}</span>
            </button>
          ))}
        </div>
        <div className="flex gap-3 justify-center">
          <button
            className="px-6 py-2.5 rounded-full border border-white/30 text-white text-sm hover:bg-white/10 transition-colors"
            onClick={onCancel}
          >
            Cancel
          </button>
          <button
            className="px-6 py-2.5 rounded-full bg-[#6a1fbf] text-white text-sm hover:bg-[#5a19a0] transition-colors font-medium"
            onClick={() => onStart(selected)}
          >
            Start Recording
          </button>
        </div>
      </div>
    </div>
  );
};

export default RecordingLayoutPicker;
